import { render, staticRenderFns } from "./DiscountSwitchToApiConnection.vue?vue&type=template&id=3feee940&scoped=true&"
import script from "./DiscountSwitchToApiConnection.vue?vue&type=script&lang=js&"
export * from "./DiscountSwitchToApiConnection.vue?vue&type=script&lang=js&"
import style0 from "./DiscountSwitchToApiConnection.vue?vue&type=style&index=0&id=3feee940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feee940",
  null
  
)

export default component.exports